import React, { Component } from 'react';
import { compose, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';


import { toggleAddProgrammePopup } from '../../redux/reducers/view';
import { getUserProgramsFullRequest,setCoachRating, setCoachRatingComment, setCoachRatingVersion, setCoachRatingQuality } from '../../redux/reducers/userProgramsFull';

import Popup from '../Popup';
import AddCodeForm from '../Form/AddCodeForm';

import { commonStyles, COLORS } from '../../styles/styles';
import addCodeKeyImage from '../../assets/add_code_key.svg';
import TextField from '@material-ui/core/TextField';


import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import StarRatings from 'react-star-ratings';
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBIcon, MDBInput } from 'mdbreact';
import {coachRatingsRequest} from '../../redux/reducers/coachRatings'




import AvatarCirce from '../AvatarCircle';
import { showRatingPopup } from '../../redux/reducers/coachRatings';
import { getTeamMembersFullRequest } from '../../redux/reducers/teamMembersFull';
import { versionStatusRequest, setVersionStatus } from '../../redux/reducers/versionStatus';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { ScaleLoader } from 'react-spinners';


class CoachRatingPopup extends Component{ 

  state = {
    modal: true
  };
  componentWillReceiveProps(nextProps){
    if(nextProps.coachRatingApi.isFetched==true && nextProps.coachRatingApi.fetching==false){
      
      nextProps.setVersionStatus('reviewed')
      nextProps.versionStatusRequest();
      this.props.showRatingPopup(false)
      this.props.getTeamMembersFullRequest();
    }
  }

  toggle = () => {
   
    this.props.showRatingPopup(false)
  }
  render(){
    const {classes, 
      handleCloseNow, 
      styles,
      handlePopupToggle,
      changeRating,
      coachRatingApi,
      coachRatingNow,
      handleSubmit, 
      changeComment, 
      coachRatingQualityNow,
      changeRatingQuality,
    } = this.props 
    console.log('XXX', this.props)
    return (<MDBContainer>
              <MDBModal isOpen={coachRatingApi.showRating} toggle={this.toggle}  centered  >
                <MDBModalHeader className="gothamBlack default-color text-white" toggle={handlePopupToggle}>Instance Rating</MDBModalHeader>
                <MDBModalBody>
                <div style={{
                           
                            height: 82,
                            border: '1 solid #f5c6cb',
                            backgroundColor: '#dc3146',textAlign:'center'}}>
                              <Typography style={{ 
                                  height: 24,
                                  color: '#FFF',
                                  fontFamily: 'PT Sans',
                                  fontSize: 45,
                                  fontWeight: 900,
                                  paddingTop: 20
                                  }}>
                              {coachRatingNow}/5
                              
                              </Typography>

                </div>
                <div style={{marginTop:20}}>
                <Typography style={{ width: 240,
                height: 24,
                color: '#363636',
                fontFamily: 'PT Sans',
                fontSize: 16,
                fontWeight: 700,
                padding:10,
                lineHeight:'50px'
                }}>
                    Quality
                </Typography>
                    <div style={{width:"100%", textAlign:'center'}}>
                      <StarRatings
                        rating={coachRatingNow}
                        starRatedColor="rgb(255, 204, 0)"
                        starHoverColor='rgb(255, 204, 0)'
                        starEmptyColor = 'rgb(221,221,221)'
                        changeRating={changeRating}
                        numberOfStars={5}
                        name='rating'
                        starDimension="18px"
                      />
                      </div>
                      </div>
                    <div style={{marginTop:20}}>
                      <Typography style={{ width: 240,
                height: 24,
                color: '#363636',
                fontFamily: 'PT Sans',
                fontSize: 16,
                fontWeight: 700,
                padding:10,
                lineHeight:'50px'
                }}>
                    Completion
                </Typography>
                    <div style={{width:"100%", textAlign:'center'}}>
                      <StarRatings
                        rating={coachRatingQualityNow}
                        starRatedColor="rgb(255, 204, 0)"
                        starHoverColor='rgb(255, 204, 0)'
                        starEmptyColor = 'rgb(221,221,221)'
                        changeRating={changeRatingQuality}
                        numberOfStars={5}
                        name='rating'
                        starDimension="18px"
                      />
                      </div>
                      </div>
                      <div className="pt-3">
        <MDBInput type="textarea" label="Comments" background getValue={changeComment}/>
        </div>
                      
                </MDBModalBody>
                <MDBModalFooter>
                  <MDBBtn size="md" color={'success'} onClick={handleSubmit}>Submit</MDBBtn>
                </MDBModalFooter>
                <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}>{this.props.coachRatingApi.fetching==true && <div onClick={(e)=>e.stopPropagation() } style={{pointerEvents:'all',backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
          <div style={{position:'absolute', top:"40%", width:'100%'}}>
        <ScaleLoader
         
         height={35}
         width={4}
         radius={2}
         margin='2px'
         color={COLORS.cornerstoneRed}
         loading={true}
       />
       </div>
        </div>}</ReactCSSTransitionGroup>

              </MDBModal>
            </MDBContainer>
    )
    }
  }
 
  // <Dialog
  //       open={true}
  //       onClose = {handleCloseNow}
  //       aria-labelledby="alert-dialog-title"
  //       aria-describedby="alert-dialog-description"
  //       classes={{paper:classes.dialogRating}}
  //     >
  //       {}
  //     <div style={{backgroundColor:'white'}}>
  //     <DialogTitle className={classes.ratingTitle} id="alert-dialog-title">
  //     <Typography style={{  width: 278,
  // height: 24,
  // color: '#363636',
  // fontFamily: 'Gotham-Black',
  // fontSize: 13,}}>
  //      MY SELF RATING
  //     </Typography>
  //     <Clear
  //           className={classes.closePopupRating}
  //           onClick={() => {
              
  //             handlePopupToggle(false)
  //             }
  //           }
  //         />
  //     </DialogTitle>
  //       <DialogContent className={classes.ratingContent}>
  //         <div style={{
  //           width: 280,
  //           height: 82,
  //           border: '1 solid #f5c6cb',
  //           backgroundColor: '#8a272a',textAlign:'center'}}>
  //              <Typography style={{ 
  // height: 24,
  // color: '#FFF',
  // fontFamily: 'PT Sans',
  // fontSize: 45,
  // fontWeight: 900,
  // paddingTop: 20
  // }}>
  //      {userRatingNow}/5
       
  //     </Typography>

  //         </div>
      
  //       <Typography style={{ width: 240,
  // height: 24,
  // color: '#363636',
  // fontFamily: 'PT Sans',
  // fontSize: 16,
  // fontWeight: 700,
  // padding:10
  // }}>
  //      My confidence level
  //     </Typography>
  //     <div style={{width:"100%", textAlign:'center'}}>
  //       <StarRatings
  //         rating={userRatingNow}
  //         starRatedColor="rgb(40,167,69)"
  //         starHoverColor='rgb(40,167,69)'
  //         starEmptyColor = 'rgb(221,221,221)'
  //         changeRating={changeRating}
  //         numberOfStars={5}
  //         name='rating'
  //         starDimension="18px"
  //       />
  //       </div>
  //       <div style={{ width: 280,
  // height: 166,
  // backgroundColor: '#f8f9fa',marginTop:20}}>
  //   <div style={{border: '1 solid #f2f2f2', textAlign:'center'}}>
  //    <TextField
  //       id="filled-multiline-static"
  //       label="Comments"
  //       multiline
  //       rows="4"
  //       className={classes.ratingsMultiLine}
  //       InputProps={{
  //         className: classes.ratingsMultiLineInput
  //       }}
  //       InputLabelProps={{
  //         classes: {
  //           root: classes.cssLabel,
  //         },
  //       }}
  //       margin="normal"
  //       variant="filled"
  //     />
  // </div>
  
  // </div>
  // <div style={{margin:10,display: "flex", justifyContent: "flex-end"}}> <Button onClick={()=>{handleSubmit()}} variant="contained"  style={{
  //       borderRadius: 0,
  //       backgroundColor: "#28a745",
  //       fontSize: "11px",
  //       color:'#fff',
  //   }}>
  //      Save &amp; Submit
  //     </Button></div>
  
       
  //       </DialogContent>
        
        
  //       </div>
       
  //     </Dialog>


const styles = () => ({
  ...commonStyles,
  image: {
    width: 64,
    height: 64,
  },
  senderAvatar: {
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 500,
    color: '#50E3C2',
    flexShrink: 0,
    marginRight: 7,
    backgroundColor: '#4A4A4A',
    width: `70px`,
    height: `70px`,
  },

});
const mapDispatchToProps = dispatch => ({
  toggleAddProgrammePopup: value => dispatch(toggleAddProgrammePopup(value)),
  setCoachRating: (int) => dispatch(setCoachRating(int)),
  setCoachRatingQuality: (int) => dispatch(setCoachRatingQuality(int)),
  setCoachRatingComment: (string) => dispatch(setCoachRatingComment(string)),
  setCoachRatingVersion: (int) => dispatch(setCoachRatingVersion(int)),
  showRatingPopup: (bool) => dispatch(showRatingPopup(bool)),
  coachRatingsRequest: () => dispatch(coachRatingsRequest()),
  getTeamMembersFullRequest: () => dispatch(getTeamMembersFullRequest()),
  versionStatusRequest:(string) => dispatch(versionStatusRequest(string)),
  setVersionStatus:(string) => dispatch(setVersionStatus(string)),
});
const mapStateToProps = state => ({
  
  coachRatingNow: state.userProgramsFullReducer.coachRating,
  coachRatingQualityNow: state.userProgramsFullReducer.coachRatingQuality,
  coachRatingApi: state.coachRatingReducer,
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    
    changeRating: props => ( newRating, name ) =>{
      
      props.setCoachRating(newRating)
    },
    changeComment: props => ( comment ) =>{
      props.setCoachRatingComment(comment);
    },
    changeRatingQuality: props => ( newRating, name ) =>{
      
      props.setCoachRatingQuality(newRating)
    },
    handleSubmit:props => () => {
     
     // props.setCoachRatingComment('hello');
      props.coachRatingsRequest();
    }

  }),
  lifecycle({
   
  }),
  withStyles(styles),
)(CoachRatingPopup);

CoachRatingPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  toggleAddProgrammePopup: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/Components/Popups/CoachRatingPopup.jsx